// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root___uaMD","title":"BackImages_title__3ft5c","images":"BackImages_images__34Kp9"};